<template>
  <div>
    <b-container fluid class="content">
      <b-alert
        :show="countdown"
        dismissible
        variant="success"
        @dismissed="countdown = 0"
        @dismiss-count-down="close_alert"
        class="show_alert"
      >
        {{ dismessage }}
      </b-alert>
      <b-row class="mt-4" v-if="currpage == 'list'">
        <b-col>
          <b-card>
            <b-row>
              <b-col cols="2">
                <el-button type="primary" size="mini" @click="back_to_category">{{ $t("Back") }}</el-button>
              </b-col>
              <b-col cols="8">
              </b-col>
              <b-col cols="2">
                <el-button type="primary" size="mini" @click="add_package">{{ $t("Add") }}</el-button>
              </b-col>
            </b-row>
            <p class="p-3" v-if="packagelist">
              <el-table
                stripe
                class="table-responsive table"
                header-row-class-name="thead-light"
                :data="packagelist"
                @row-click="row_clicked_event"
                ref="dragTable"
                row-key="IDn"
              >
                <!-- <el-table-column label="ID" prop="IDn">
                  <template v-slot="{ row }">
                    {{ row.IDn }}
                  </template>
                </el-table-column> -->
                <el-table-column :label="$t('Name')" prop="Name">
                </el-table-column>
                <el-table-column label="Status" prop="PLU">
                  <template v-slot="{ row }">
                    <div v-if="row.Status==1">Uploaded</div>
                    <div v-else-if="row.Status==2">Disabled</div>
                    <div v-else>Changed</div>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="CategoryIds" prop="PackageData">
                  <template v-slot="{ row }">
                  </template>
                </el-table-column> -->
                <el-table-column>
                  <template v-slot="{ row }">
                    <!-- <el-button v-if="row.Status != 1"
                      type="primary"
                      size="mini"
                      @click="back_to_category"
                    >{{
                      $t("Back")
                    }}</el-button> -->
                    <el-button v-if="row.Status != 2"
                      type="danger"
                      size="mini"
                      @click="disable_package(row, $event)"
                    >{{
                      $t("Disable")
                    }}</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <b-row>
                <b-col class="text-center mt-5">
                  <el-button type="primary" size="mini" @click="send_to_ow"
                  >{{ $t("Send To") + ' OW' }}</el-button>
                </b-col>
              </b-row>
            </p>
            <p class="p-3" v-else>
              {{ $t("No Records") }}
            </p>
          </b-card>
        </b-col>
      </b-row>

      <b-row class="mt-4" v-if="currpage == 'edit'">
        <b-col>
          <b-card no-body>
            <b-card-body>
              <b-form>
                <b-row>
                  <b-col cols="8" class="text-center">
                    <p>{{ cur_category_package.IDn }}</p>
                  </b-col>
                </b-row>
                <b-row class="mb-3">
                  <b-col cols="4" class="text-right pr-6">
                    {{$t('Name')}}
                  </b-col>
                  <b-col cols="4">
                    <el-input
                      placeholder="Name"
                      size="small"
                      v-model="cur_category_package.Name"
                      @change="changed_name"
                      required
                    />
                  </b-col>
                </b-row>
                <b-row class="mb-3">
                  <b-col cols="4" class="text-right pr-6">
                    {{$t('Status')}}
                  </b-col>
                  <b-col cols="4">
                    <el-select v-model="cur_category_package.Status" size="mini">
                      <el-option v-for="item in status_options" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled"></el-option>
                    </el-select>
                  </b-col>
                </b-row>
                <b-row v-for="(cate, idx) in categorylist" :key="idx">
                  <b-col cols="4" class="text-right pr-6">
                  </b-col>
                  <b-col cols="4">
                    <el-switch
                      v-model="isInCurPackage[idx]"
                      :active-text="cate.Name1"
                      @change="toggleCurPacage(cate, $event)"
                    >
                    </el-switch>
                  </b-col>
                </b-row>

                <b-row class="mt-3">
                  <b-col class="text-center">
                    <el-button type="primary" @click="form_cancel">{{
                      $t("Back")
                    }}</el-button>
                  </b-col>
                  <b-col class="text-center">
                    <el-button type="primary" @click="form_submit">{{
                      $t("Submit")
                    }}</el-button>
                  </b-col>
                </b-row>
              </b-form>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

      <b-row class="mt-4">
        <b-col> </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { Table, TableColumn, Button, Checkbox, Row, Col, Dropdown, Dialog, Tabs, TabPane, Select, Option, Switch } from "element-ui";
import { getStore, setStore } from "../../util/helper";
import { hasUtilityAuth } from "../../directives/acl";
// import ElTableDraggable from '../../../node_modules/el-table-draggable';

const axios = require("axios");

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Row.name]: Row,
    [Col.name]: Col,
    [Dropdown.name]: Dropdown,
    [Dialog.name]: Dialog,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Select.name]: Select,
    [Option.name]: Option,
    [Switch.name]: Switch,
    // ElTableDraggable,
  },
  data() {
    return {
      currpage: "list",
      cur_category_package: null,
      cur_opt: null,
      new_category_package: {
        IDn: 0,
        Status: 0,    // 0: Not uploaded, 1: Uploaded, 2: Disabled
        Type: "OW",   // Current OW Only
        Name: "",     // Package Name For display
        PackageData: [],  // Cagegory IDn
        UserIDn: 0,   // Operation User IDn',
        // LastUpdate: "", Only has it when read from server
      },
      packagelist: null,
      categorylist: null, // Cagegory list
      cur_Package: [],  // Cagegory IDn

      status_options: [
        {value: "0", label: "Changed", disabled: false},
        {value: "1", label: "Uploaded", disabled: true},
        {value: "2", label: "Disabled", disabled: false},
      ],

      dismessage: "",
      countdown: 0,

      token: "",
      user_id: 0,
    };
  },
  computed: {
    apiBaseUrl: function () {
      return axios.defaults.baseURL + "/Api";
    },
    isInCurPackage() {
      return this.categorylist.map((item) => this.cur_Package.includes(item.IDn));
    }
  },
  methods: {
    hasUtilityAuth,
    changed_name() {
      this.cur_category_package.Status="0";
    },
    toggleCurPacage(category, e) {
      // console.log("OwCategoryPackage.vue computed toggleCurPacage", category, e); //XXXXXXXXXXXXXXXXXXXXXX
      if (e) {
        // Add category.IDn to cur_Package if switch is turned on and category.IDn is not already present
        if (!this.cur_Package.includes(category.IDn)) {
          this.cur_Package.push(category.IDn);
        }
      } else {
        // Remove category.IDn from cur_Package if switch is turned off
        this.cur_Package = this.cur_Package.filter((IDn) => IDn !== category.IDn);
      }
      this.cur_category_package.Status="0";
      console.log("OwCategoryPackage.vue computed toggleCurPacage", 'Toggled:', category, 'Switch state:', e, 'Target Array:', this.cur_Package);
    },
    close_alert(countDownChanged) {
      this.countdown = countDownChanged;
      if (this.countdown == 0) {
        this.dismessage = "";
      }
    },
    add_package() {
      this.currpage = "edit";
      this.cur_category_package = JSON.parse(JSON.stringify(this.new_category_package));
      this.cur_Package = [];
      this.cur_opt = "add";
    },
    back_to_category() {
      this.$router.push("/category");
    },
    row_clicked_event(row, event, column) {
      // console.log("row_clicked_event", row, event, column);
      if (!hasUtilityAuth('CategoryEdit')) return;
      this.currpage = "edit";
      this.cur_category_package = JSON.parse(JSON.stringify(row));
      this.cur_Package = JSON.parse(this.cur_category_package.PackageData);
      this.cur_opt = "update";
    },
    form_cancel() {
      this.currpage = "list";
    },
    async send_to_ow(event) {
      if (event) {
        event.preventDefault();
      }
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      var that = this;

      axios({
        method: "post",
        url: "/Api/Web/Category_package/send_to_ow",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.dismessage = that.$t("Data Updated Successfully");
              that.countdown = 3;
              that.get_package_list();
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
    },
    async disable_package(row, event) {
      if (event) {
        event.preventDefault();
      }
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("IDn", row.IDn);
      bodyFormData.append("Status", 2); // Disabled
      var that = this;

      axios({
        method: "post",
        url: "/Api/Web/Category_package/update_status",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.dismessage = that.$t("Data Updated Successfully");
              that.countdown = 3;
              that.form_cancel();
              that.get_package_list();
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
    },
    async form_submit(event) {
      if (event) {
        event.preventDefault();
      }
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("opt", this.cur_opt);
      var that = this;
      for (var key in this.cur_category_package) {
        if (key == 'LastUpdate') {
          continue;
        } else if (key == 'UserIDn') {
          bodyFormData.append(key, this.user_id);
        } else if (key == 'PackageData') {
          bodyFormData.append(key, JSON.stringify(this.cur_Package));
        } else {
          bodyFormData.append(key, this.cur_category_package[key]);
        }
      }

      axios({
        method: "post",
        url: "/Api/Web/Category_package/edit",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.dismessage = that.$t("Data Updated Successfully");
              that.countdown = 3;
              that.form_cancel();
              that.get_package_list();
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
    },
    async get_package_list() {
      // this will be called only after form is valid. You can do api call here to login
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);

      var that = this;
      axios({
        method: "post",
        url: "/Api/Web/Category_package",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.packagelist = rt.data.packages;
              that.categorylist = rt.data.categorys;
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          } else {
            this.$router.push("/login");
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
    },
    async init_data() {
      this.token = getStore("token");
      this.user_id = getStore("user_id");
      if (!this.token || !this.user_id) {
        this.$router.push("/login");
        return;
      }
      return this.get_package_list();
    },
  },
  mounted() {
    this.init_data();
    this.windowHeight = window.innerHeight;
  },
};
</script>
<style>
.content {
  padding-top: 80px;
}
.select_text {
  margin-left: -1rem;
}
.handshape{
  cursor: pointer;
}
.text-left {
  text-a: 14rem;
}
</style>
